import { Link } from 'react-router-dom';
import { heroArticles } from '@/mocks/homeData';

export default function HeroSection() {
  const mainArticle = heroArticles[0];
  const secondArticle = heroArticles[1];

  return (
    <section className="relative w-full pt-24 pb-12 md:pt-32 md:pb-16 px-4 md:px-6">
      <div className="absolute inset-0 bg-gradient-to-b from-background-100/50 to-background-50"></div>
      <div className="relative max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
          <div className="lg:w-[35%] flex flex-col justify-center">
            <Link to="/" className="group">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-3">
                {mainArticle.title}
              </h1>
              <p className="text-xl md:text-2xl font-heading italic text-foreground-700 mb-4">
                {mainArticle.subtitle}
              </p>
              <p className="text-sm text-foreground-500 leading-relaxed mb-5 line-clamp-3">
                {mainArticle.summary}
              </p>
              <div className="flex items-center gap-3 mb-5 flex-wrap">
                {mainArticle.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 text-xs bg-secondary-100 text-secondary-700 rounded-full"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                阅读全文
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </div>
              </span>
            </Link>
          </div>

          <div className="lg:w-[35%]">
            <Link to="/" className="block group cursor-pointer">
              <div className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden">
                <img
                  src={mainArticle.image}
                  alt={mainArticle.title}
                  title={`${mainArticle.title} - 51吃瓜app`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="eager"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
            </Link>
          </div>

          <div className="lg:w-[30%] flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-heading font-bold text-foreground-900">
                热门爆料
              </h2>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-foreground-600"></i>
              </div>
            </div>

            <Link to="/" className="block group cursor-pointer">
              <div className="relative w-full aspect-[16/9] rounded-xl overflow-hidden mb-3">
                <img
                  src={secondArticle.thumbImages[0]}
                  alt={secondArticle.title}
                  title={`${secondArticle.title} - 51吃瓜app`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute bottom-2 left-2 px-2.5 py-1 text-xs bg-background-50/90 text-foreground-900 rounded-lg">
                  {secondArticle.tags[0]}
                </span>
              </div>
            </Link>

            <div className="grid grid-cols-2 gap-3">
              {secondArticle.thumbImages.slice(1).map((img, i) => (
                <Link
                  key={i}
                  to="/"
                  className="block group cursor-pointer"
                >
                  <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden">
                    <img
                      src={img}
                      alt={`${secondArticle.title} 图片${i + 2}`}
                      title={`${secondArticle.title} - 51吃瓜app`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <span className="absolute bottom-1.5 left-1.5 px-2 py-0.5 text-[10px] bg-background-50/90 text-foreground-900 rounded-md">
                      {secondArticle.tags[i + 1] || secondArticle.tags[0]}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}